import { createFileRoute } from '@tanstack/react-router'
import EvaluationPromptCreation from '@/features/evaluation-prompts/evaluation-prompt-creation'

export const Route = createFileRoute(
  '/_authenticated/evaluation-prompt-creation/'
)({
  component: EvaluationPromptCreation,
})
